/* <!-- DYGAMING: javascript for homepage --> */
/* NOTE: CODE HERE GETS EXECUTED GLOBALLY. SCOPE YOUR DECLARATIONS */

(function() {
  function updateTabsAndMatches(event) {
    var element = event.target;
    var sport = element.getAttribute('data-sport');
    var tabs = document.querySelectorAll('.bet-group-tab');
    tabs.forEach(function(tab) {
      tab.classList.remove('active');
      document.querySelectorAll('.list-view-item[data-sport]').forEach(function(listViewItem) {
        listViewItem.classList.remove('active');
      });
    });
    element.classList.add('active');
    document.querySelectorAll('.list-view-item[data-sport="' + sport + '"]').forEach(function(listViewItem) {
      listViewItem.classList.add('active');
    });
  }
  
  document.querySelectorAll('.bet-group-tab').forEach(function(betTab) {
    betTab.addEventListener('click', updateTabsAndMatches);
  });
  
  updateTabsAndMatches({target: document.querySelectorAll('.bet-group-tab')[0]});
  
})();
  


/* <!-- DYGAMING: create our own add-to-cart events since default Shopify implementation will be incorrect --> */
(function() {
  function fireDyCartEventFromCartJs(event) {
    var target = event.target;
	
    if (CartJS.cart.item_count > 0) {
      var sku = target.getAttribute('data-variant-sku');
      var totalPrice = CartJS.cart.total_price;
      var _dy_order_cart = [];
      var cartJsCart = CartJS.cart.items;
      for (var _index = 0; _index < cartJsCart.length; _index ++) {
        _dy_order_cart.push({
          productId: cartJsCart[_index].sku,
          quantity: cartJsCart[_index].quantity,
          itemPrice: parseFloat(cartJsCart[_index].final_line_price),
        });
      }

      setTimeout(function() {
        DY.API('event' , {
          name:'Add to Cart',
          properties: {
            dyType : 'add-to-cart-v1',
            value: parseFloat(totalPrice),
            currency: 'USD',
            quantity: 1,
            productId: sku,
            cart: _dy_order_cart
          }
        });
      }, 200);
    } 
  }

  const buttons = document.querySelectorAll(".list-bet-button button")
  for (const button of buttons) {
    button.addEventListener('click', fireDyCartEventFromCartJs);
  }
})();